import React from "react";
const SideBar = React.memo(({ isChat, isMember, hideMember, hideChat, renderMember, renderChat }) => {
    return (React.createElement("div", { className: "sidebar" },
        isMember && React.createElement("div", { className: "item", key: "member", style: { maxHeight: !hideMember ? isChat && !hideChat ? "30%" : "100%" : "35px" } }, renderMember),
        isChat && React.createElement("div", { className: "item", key: "chat", style: { maxHeight: !hideChat ? isMember && !hideMember ? "70%" : "100%" : "35px" } }, renderChat)));
});
export default SideBar;
